import Link from "next/link";
import { useRouter } from "next/router";

import { useCallback, useEffect } from "react";

import ISO6391 from "iso-639-1";

import AlertBox from "components/AlertBox";

const TranslationNav = () => {
  const router = useRouter();

  const { lang: langQuery, slug, ...restOfQuery } = router.query;
  const lang = langQuery as string;

  const browserLang =
    navigator.languages
      .filter((l) => ["ja", "ko"].some((tl) => l.includes(tl)))[0]
      ?.slice(0, 2) || "en";
  const browserLangName = ISO6391.getName(browserLang);

  useEffect(() => {
    if (!!router.query["magic-token"]) return;
    if (!!router.query["temporary-token"]) return;

    if (
      ["ja", "ko"].includes(lang) &&
      !["ja", "ko"].includes(sessionStorage.getItem("sk-source-lang") || "")
    ) {
      sessionStorage.setItem("sk-source-lang", lang);
    }

    const preferredLang = sessionStorage.getItem("sk-preferred-lang");
    if (preferredLang) {
      if (lang !== preferredLang) {
        // TODO: improve
        if (lang && lang !== "en") {
          sessionStorage.setItem("sk-preferred-lang", lang);
        }

        if (preferredLang === "en") {
        } else {
          router.replace({
            pathname:
              "/" +
              preferredLang +
              location.pathname.replace(/\/[a-z]{2}\//, "/"),
            query: {
              ...restOfQuery,
            },
          });
        }
      }
    } else {
      if (lang) {
        sessionStorage.setItem("sk-preferred-lang", lang);
      } else {
        if (browserLang) {
          sessionStorage.setItem("sk-preferred-lang", browserLang);

          router.replace({
            pathname:
              "/" +
              browserLang +
              location.pathname.replace(/\/[a-z]{2}\//, "/"),
            query: {
              ...restOfQuery,
            },
          });
        }
      }
    }
  }, [browserLang, lang, restOfQuery, router]);

  const onSwitchLang = useCallback((lang: string) => {
    sessionStorage.setItem("sk-preferred-lang", lang);
  }, []);

  if (lang && lang !== "en")
    return (
      <AlertBox className="my-[15px]">
        This page has been machine-translated. Click{" "}
        <Link
          href={{
            pathname: location.pathname
              .replace(`/${browserLang}`, "")
              .replace(`/${lang}`, ""),
            query: restOfQuery,
          }}
          className="text-smart-teal"
          onClick={() => onSwitchLang("en")}
        >
          here
        </Link>{" "}
        to revert to original page
      </AlertBox>
    );

  if (browserLang !== "en")
    return (
      <AlertBox className="my-[15px]">
        Click{" "}
        <Link
          href={{
            pathname: "/" + browserLang + router.pathname,
            query: { ...restOfQuery, slug },
          }}
          className="text-smart-teal"
          onClick={() => onSwitchLang(browserLang)}
        >
          here
        </Link>{" "}
        to translate the content to {browserLangName}.
      </AlertBox>
    );

  return <></>;
};

export default TranslationNav;
